import type { JSX } from 'react';

import type { OffeneTageJeStandort } from '../api/tagesplanung';
import { alsTag } from '../datum';

/**
 * DIE OFFENEN PLANUNGEN ALLER STANDORTE (TAG-33, Auftrag CRM-68).
 *
 * Auftraggeber, 06.10.2026: „derzeit wird nur ein Standort angezeigt. es soll
 * sichtbar sein, wenn an Standorten noch Planungen in der nächsten zeit offen
 * sind."
 *
 * NUR DIE ANZAHL (Auftrag CRM-81). Auftraggeber, 06.10.2026: „schreibe bei
 * triningsplanung unter offene Planungen nur die Anzahl je Standort und
 * öffne beim klick die liste." Je Standort ein Kärtchen mit Bezeichnung und
 * der Zahl der Tage, die im Zeitraum der Liste noch „in Planung" stehen.
 * Gezählt hat die API — die Maske zeigt nur, was sie bekommt. Der früheste
 * offene Tag steht nur noch im Hinweis (`title`).
 *
 * DIE WARNUNG STEHT ALS TEXT DA (WCAG 1.4.1): „3 offen" in der Achtungsmarke,
 * die Kante links in derselben Farbe wie am Widget. Ein Standort ohne offenen
 * Tag bleibt ruhig: „0 offen" ohne Marke.
 *
 * Ein Klick führt in die Liste der Tage dieses Standorts; die offenen Tage
 * sind dort als „in Planung" markiert (CRM-68).
 */
export function OffenePlanungen({
  standorte,
  gewaehlt,
  bis,
  beiWahl,
}: {
  readonly standorte: readonly OffeneTageJeStandort[];
  /** Der Standort, dessen Tage gerade zu sehen sind. */
  readonly gewaehlt: string;
  /** Das Ende des Zeitraums — „in der nächsten Zeit" ist der der Liste. */
  readonly bis: string;
  readonly beiWahl: (standort: string) => void;
}): JSX.Element | null {
  if (standorte.length === 0) return null;
  return (
    <section className="planungsuebersicht" aria-labelledby="planungsuebersicht-titel">
      <h2 id="planungsuebersicht-titel" className="planungsuebersicht__titel">
        Offene Planungen bis {alsTag(bis)}
      </h2>
      <ul className="planungsuebersicht__liste">
        {standorte.map((s) => {
          const offen = s.offeneTage > 0;
          return (
            <li key={s.kennung}>
              <button
                type="button"
                className={
                  offen
                    ? 'planungsuebersicht__standort planungsuebersicht__standort--achtung'
                    : 'planungsuebersicht__standort'
                }
                {...(s.kennung === gewaehlt ? { 'aria-current': 'true' as const } : {})}
                {...(s.fruehesterTag === null ? {} : { title: `ab ${alsTag(s.fruehesterTag) ?? s.fruehesterTag}` })}
                onClick={() => {
                  beiWahl(s.kennung);
                }}
              >
                <strong>{s.bezeichnung}:</strong>{' '}
                {offen ? (
                  <span className="marke marke--warn">{s.offeneTage} offen</span>
                ) : (
                  <span className="hilfe">0 offen</span>
                )}
              </button>
            </li>
          );
        })}
      </ul>
    </section>
  );
}
